import service from '@/api/statistics';
import {handleError} from '@/state/generators/helpers';
/*const _ = require("lodash");*/

export const state = {
    loading: false,
    loadingMonth: false,
    item: {},
    list: [],
    month: [],
    service: service('performance'),
}

export const getters = {
    loading: function (state) {
        return !!state.loading
    },
    loadingMonth: function (state) {
        return !!state.loadingMonth
    },
    item: function (state) {
        return JSON.parse(JSON.stringify(state.item));
    },
    list: function (state) {
        return JSON.parse(JSON.stringify(state.list));
    },
    categories: function (state) {
        return state.item.categories;
    },
    categoryExtra: function (state) {
        return state.item.category_extra;
    },
    categorySummary: function (state) {
        return state.item.category_summary;
    },
    executions: function (state) {
        return state.item.executions;
    },
    commissionSummary: function (state) {
        return state.item.commission_summary;
    },

    executionSummary: function (state) {
        return state.item.execution_summary;
    },
    efficiency: function (state) {
        return state.item.efficiency;
    },
    projectTypes: function (state) {
        return state.item.project_types;
    },
    headerCategories: function (state) {
        if (!state.item.categories) {
            return [];
        }

        const month = (new Date()).getMonth() + 1;

        return Object.values(state.item.categories)?.filter((item) => {
            return item.code !== 'minuses';
        }).slice(0, 3).map((item) => {
            const copy = Object.assign({}, item);
            copy.value = copy.months[month];
            return copy;
        });
    },
    currentMonth: function (state) {
        if (! state.item.current_month) {
            return [];
        }

        return JSON.parse(JSON.stringify(state.item.current_month));
    },
    month: function (state) {
        return JSON.parse(JSON.stringify(state.month));
    }
}

export const mutations = {
    'SET_LOADING': function (state, boolean = true) {
        state.loading = boolean;
    },

    'SET_LOADING_MONTH': function (state, boolean = true) {
        state.loadingMonth = boolean;
    },

    'SET_LIST': function (state, list) {
        state.list = list;
    },

    'SET_ITEM': function (state, item = {}) {
        state.item = item;
    },

    'SET_MONTH': function (state, month = {}) {
        state.month = month;
    },

    'INCREASE_CATEGORY': function (state, {id, value}) {
        state.categories[id].value += value;

        state.categories[id].percentage = state.categories[id].target ? Math.round(state.categories[id].value / state.categories[id].target) : 100;

        state.categories[id].completed = state.categories[id].percentage === 100;
    }
}

export const actions = {
    annual: function ({commit, state}, userId) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_LOADING', true);

        return state.service.annual(userId).then(response => {
            commit('SET_ITEM', response);
            commit('app/SET_LOADING', false, {root: true});
            commit('SET_LOADING', false);
            return response;
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    increaseCategory: function ({commit}, {id, value}) {
        commit('INCREASE_CATEGORY', {id: id, value: value});
    },

    monthly: function ({commit, state}, {userId, categoryId, month}) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_LOADING_MONTH', true);

        return state.service.monthly(userId, categoryId, month).then(response => {
            commit('SET_MONTH', response.data);
            commit('app/SET_LOADING', false, {root: true});
            commit('SET_LOADING_MONTH', false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit)
        });
    },

    annualList: function ({commit, state}) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_LOADING', true);

        return state.service.annualList().then(response => {
            commit('SET_LIST', response.data)
            commit('app/SET_LOADING', false, {root: true});
            commit('SET_LOADING', false);
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    },
}
